
<div id="divWeatherMain"> 
    <div *ngIf="WeatherData.isDay" class="weatherWidgetRow">
        <i class="fas fa-3x fa-sun sun"></i>  
    </div>   
    <div *ngIf="!WeatherData.isDay" class="weatherWidgetRow">
        <i class="fas fa-3x fa-moon moon"></i>  
    </div>   
    <div class="weatherWidgetRow cloudDiv">
        <i class="fas fa-cloud fa-3x cloud"></i>
    </div>
    <div class="weatherWidgetRow" style="font-size: 32px;margin-top: 5px;">{{WeatherData.temp_celcius}}°</div>
    <div class="weatherWidgetRow font-size12" >{{WeatherData.temp_min}}° / {{WeatherData.temp_max}}°</div>
    <div class="weatherWidgetRow font-size12" >Feels Like: {{WeatherData.temp_feels_like}}°</div>
    <div class="weatherWidgetRow" style="font-size: 25px;margin-top: 10px;">{{WeatherData.name}}</div>
    <div class="weatherWidgetRow font-size12" >Humidity: {{WeatherData.main.humidity}}%</div>
</div>
